import { createSelector } from 'reselect'

export const getSettings = (state) => state.mars.settings
export const getUserInfo = (state) => state.auth.userInfo

export const getAvailableLanguages = createSelector([getSettings], (settings) => {
  const langs = settings.availableLanguages
  if (langs && Array.isArray(langs)) {
    return langs
  } else if (langs && langs.languages && Array.isArray(langs.languages)) {
    return langs.languages
  } else {
    return []
  }
})

export const getSoundBackground = createSelector(
  [getSettings],
  (settings) => settings.soundBackground
)
export const getlocale = createSelector([getUserInfo], (userInfo) =>
  userInfo && userInfo.licenseData ? userInfo.licenseData.lang : 'en'
)
export const getSoundEffects = createSelector([getSettings], (settings) => {
  return settings.soundEffects
})

export const getShadowState = createSelector([getSettings], (settings) => {
  return settings.shadows
})
export const getSoundMusic = createSelector([getSettings], (settings) => {
  return settings.soundMusic
})
export const getSoundVoices = createSelector([getSettings], (settings) => {
  return settings.soundVoices
})
export const canShowOnlyHelp = createSelector([getSettings], (settings) => {
  return settings.showOnlyHelp
})
